






































import { Component, Vue, Prop, Mixins } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { StoreModule } from "@/store/types";
import { OrderGetters } from "@/store/modules/order/types";
import { Mobile } from "@/mixins/mobile";
import SurchargeBanner from "@/components/footer/SurchargeBanner.vue";
import EditMultiplier from "@/components/elements/utility/EditMultiplier.vue";
@Component({ components: { SurchargeBanner, EditMultiplier } })
export default class AddListToQuoteFooter extends Mixins(Mobile) {
  @(namespace(StoreModule.Order).Getter(OrderGetters.GetAssignedCustomer))
  customer!: string;
  @Prop() itemPriceTotal!: number;
  @Prop() msrpTotal!: number;
  @Prop() isSubmitDisabled!: boolean;

  protected submitItem(): void {
    this.$emit("addToQuote");
  }
}
